import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "rich-text-input",
  standalone: false,
  templateUrl: "./rich-text-input.component.html",
  styleUrl: "./rich-text-input.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RichTextInputComponent {
  public modules = input.required();
  public form = input.required<FormGroup>();
  public id = input.required<string>();
  public readOnly = input<boolean>(false);
  public bgClass = input<string>();
  public placeholder = input<string>();
  public onContentChanged = output();
  public onEditorChanged = output();
}
